export const CELL_STYLES = {
  present: "bg-green-100 text-green-800",
  half_day: "bg-purple-100 text-purple-800",
  absent: "bg-red-100 text-red-700",
  leave: "bg-amber-100 text-amber-800",
  holiday: "bg-blue-50 text-blue-700",
  weekoff: "bg-stone-100 text-stone-400",
  future: "bg-white text-stone-300 border border-stone-100",
  na: "bg-white text-stone-200 border border-stone-100",
};

const cellLabel = (d) => {
  if (d.status === "present") return d.hours != null ? `${d.hours}h` : d.check_in;
  if (d.status === "half_day") return "½ day";
  if (d.status === "leave") return d.label;
  if (d.status === "holiday") return "Holiday";
  if (d.status === "absent") return "Absent";
  return "";
};

export const AttendanceCell = ({ day }) => (
  <div data-testid={`calendar-day-${day.date}`} title={day.label || day.status}
    className={`rounded-lg p-1.5 min-h-[52px] flex flex-col items-center justify-center ${CELL_STYLES[day.status]}`}>
    <span className="text-sm font-bold tabular-nums">{+day.date.slice(8)}</span>
    <span className="text-[10px] leading-tight text-center truncate w-full">{cellLabel(day)}</span>
  </div>
);
